import Logo1 from "../../../assets/images/logo1.png";
import Logo2 from "../../../assets/images/logo2.svg";
import { useSelector } from "react-redux";
import moment from "moment";
import numeral from "numeral";
import { currencySymbol } from "../../../utils/constants";
import { useMemo } from "react";

const CreditMemoReportHeader = () => {
  const { creditMemoReportPrint } = useSelector((state) => state);
  const brand = useMemo(() => new URLSearchParams(window.location.search).get("brand"), []);
  const _logo = brand === "DL1961" ? Logo1 : Logo2;
  const headerData = creditMemoReportPrint && creditMemoReportPrint?.payload?.data[0];
  let sumAmount = creditMemoReportPrint?.payload?.data.reduce(function (
    previousValue,
    currentValue
  ) {
    return (previousValue += parseFloat(
      currentValue.amount
    ));
  },
    0);
  
    let sumDiscount = creditMemoReportPrint?.payload?.data.reduce(function (
    previousValue,
    currentValue
  ) {
    return (previousValue += parseFloat(
      currentValue.discount
    ));
  },
    0);

    console.log("sumDiscount", sumDiscount)

  return (
    <div className="__header">
      <table width="100%">
        <tbody>
          <tr>
            <td width="100%" style={{ paddingRight: "5px" }}>
              <table width="100%">
                <tbody>
                  <tr>
                    <td>
                      <table width="100%">
                        <tbody>
                          <tr>
                            <td>
                              <div className="__image_container">
                                <img width={150} height={26} src={_logo} alt="Brand Logo" />
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td valign="top" width="100%">
                              <div className="__addr">
                                <p>DLPD CANADA LTD.</p>
                                <p>15 Wertheim Court, Suite 409,</p>
                                <p>Richmond Hill, ON L4B 3H7 , Canada</p>
                                <p>Business # : 763395530RT0001</p>
                                <p>Email : orderca@dl1961.com</p>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <table width="50%">
                        <tbody>
                          <tr>
                            <td width="50%" >
                              <table width="100%" className="__addr_table">
                                <thead>
                                  <tr>
                                    <th>Customer Billing</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>
                                      <p>
                                        {headerData && headerData.customer_name}
                                      </p>
                                      <p>
                                        {headerData && headerData.address_1}
                                      </p>
                                      <p>
                                        {headerData && headerData.address_2}
                                      </p>
                                      <p>
                                        {headerData && headerData.city_name + " " + headerData.state_name + " " + headerData.zip_code}
                                      </p>
                                      <p>
                                        {headerData && headerData.country_name}
                                      </p>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                            <td width="50%" >
                              <table width="100%" className="__addr_table">
                                <thead>
                                  <tr>
                                    <th>Customer Shipping</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>
                                      <p>
                                        {headerData && headerData.ship_customer_name}
                                      </p>
                                      <p>
                                        {headerData && headerData.ship_address_1}
                                      </p>
                                      <p>
                                        {headerData && headerData.ship_address_2}
                                      </p>
                                      <p>
                                        {headerData && headerData.ship_city_name + " " + headerData.ship_state_name + " " + headerData.ship_zip_code}
                                      </p>
                                      <p>
                                        {headerData && headerData.ship_country_name}
                                      </p>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      {headerData && headerData.memo && (
                        <div style={{ marginTop: 15, width: 600 }}>
                          <span><span style={{ fontWeight: 600 }}>Memo</span> : {headerData && headerData.memo}</span>
                        </div>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td className="__box_wrapper" valign="top" style={{ paddingLeft: "5px" }}>
              <table className="__box">
                <tbody>
                  <tr>
                    <td>Credit Note#{headerData && headerData.note_header_no}</td>
                  </tr>
                  <tr>
                    <td>RA#{headerData && headerData.ra_no}</td>
                  </tr>
                  <tr>
                    <td>Invoice#{headerData && headerData.invoice_header_no}</td>
                  </tr>
                  <tr>
                    <td>
                      <div style={{ padding: '10px 0' }}>Date:{headerData && moment(headerData.note_date).format("MM/DD/YYYY")}</div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p><span>TOTAL</span>{currencySymbol}{numeral(sumAmount - (headerData?.re_stock || 0) - (headerData?.return_label_fee || 0)).format("00.00")}</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default CreditMemoReportHeader;
